/**
 * PCS-11271: 14-day Toriut trial lifecycle — expiration, conversion & cancellation flow.
 * Reason IDs mirror `server/app/toriutTrial/cancellation/constants.js` exactly —
 * they are sent verbatim to the backend and to Amplitude.
 */
export const REASON_IDS = Object.freeze({
  MISSING_CAPABILITY: 'missing_capability',
  SETUP_EFFORT: 'setup_effort',
  PRODUCT_DATA: 'product_data',
  SHOPIFY_WORKFLOW: 'shopify_workflow',
  WORKFLOW_FIT: 'workflow_fit',
  PRICING_SETUP: 'pricing_setup',
  EVALUATION_TIME: 'evaluation_time',
  ALTERNATIVE: 'alternative',
  NOT_READY: 'not_ready',
  OTHER: 'other',
});

export const REASON_ORDER = Object.freeze([
  REASON_IDS.MISSING_CAPABILITY,
  REASON_IDS.SETUP_EFFORT,
  REASON_IDS.PRODUCT_DATA,
  REASON_IDS.SHOPIFY_WORKFLOW,
  REASON_IDS.WORKFLOW_FIT,
  REASON_IDS.PRICING_SETUP,
  REASON_IDS.EVALUATION_TIME,
  REASON_IDS.ALTERNATIVE,
  REASON_IDS.NOT_READY,
  REASON_IDS.OTHER,
]);

export const MIN_SELECTED_REASONS = 1;
export const MAX_SELECTED_REASONS = 3;
export const MAX_FEEDBACK_LENGTH = 500;

export const STEPS = Object.freeze({
  TRIAL_EXPIRED: 'trial_expired',
  GET_FULL_ACCESS: 'get_full_access',
  SELECT_REASONS: 'select_reasons',
  DETAILED_FEEDBACK: 'detailed_feedback',
  FEEDBACK_CALL: 'feedback_call',
  CLOSE_ACCOUNT: 'close_account',
  DATA_DELETION_SUBMITTED: 'data_deletion_submitted',
  DATA_RESTRICTION_SUBMITTED: 'data_restriction_submitted',
  // After the 30-day retention cron wiped workspace catalog data (`dataDeletedAt`).
  WORKSPACE_DATA_DELETED: 'workspace_data_deleted',
});

/**
 * PCS-11271: which reused Settings → Privacy form (Delete all personal data /
 * Restrict processing) the user just submitted - drives both which terminal
 * "…request has been submitted" copy `DataRequestSubmittedStep` shows and
 * which of the two persisted `user` flags `ToriutTrialFlow` reads on mount.
 */
export const DATA_REQUEST_TYPES = Object.freeze({
  DELETION: 'deletion',
  RESTRICTION: 'restriction',
});

/** Calendly integration: reuses the server-rendered page behind the existing Sales flow. */
export const CONTACT_DEMO_CALENDLY_PATH = '/setup/contactDemoCalendly';
export const CALENDLY_CONTEXT = Object.freeze({
  SALES: 'pim',
  PM: 'pm',
});
